import { render, staticRenderFns } from "./AttributeUpdate.vue?vue&type=template&id=13b47610&"
import script from "./AttributeUpdate.vue?vue&type=script&lang=js&"
export * from "./AttributeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports